import type { CaseStudy } from "./types";

const PRIVATE_CASE_STUDY_ID = 37;

type CaseStudyReference = Pick<CaseStudy, "id">;

export function isPrivateCaseStudy(caseStudy: CaseStudyReference): boolean {
  return caseStudy.id === PRIVATE_CASE_STUDY_ID;
}

export function filterPublicCaseStudies<T extends CaseStudyReference>(caseStudies: readonly T[]): T[] {
  return caseStudies.filter((caseStudy) => !isPrivateCaseStudy(caseStudy));
}
